export default __webpack_public_path__ + "static/media/bg04.ed4d7cdb.jpg";